import { SERVICES } from "@/data/mock";

export default function AdminServiceCatalog() {
  const phases = [1, 2, 3];
  return (
    <div className="space-y-8">
      <div>
        <div className="eyebrow">// Service Catalog</div>
        <h1 className="display-lg text-silver-50 mt-2">14 Services · 3 Phases</h1>
      </div>
      <div className="grid gap-6 lg:grid-cols-3">
        {phases.map((p) => (
          <div key={p} className="panel p-6">
            <div className="flex items-center justify-between">
              <div className="eyebrow">// Phase {p}</div>
              <span className={p === 2 ? "chip-red" : "chip"}>{p === 2 ? "BSS ≥ 75" : p === 1 ? "Foundation" : "Retention"}</span>
            </div>
            <div className="hairline my-5" />
            <ul className="space-y-4">
              {SERVICES.filter((s) => s.phase === p).map((s) => (
                <li key={s.code} className="border-l-2 border-brand-blue/40 pl-4">
                  <div className="flex items-center justify-between">
                    <div className="font-display font-semibold text-silver-50">{s.name}</div>
                    <span className="font-mono text-[10px] uppercase text-silver-300">effort {s.effort}</span>
                  </div>
                  <div className="text-silver-300 text-xs mt-1">{s.summary}</div>
                  <div className="font-mono text-[10px] text-brand-blue mt-1">{s.code}</div>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
